module.exports = __webpack_public_path__ + "static/media/fly0129.a882a182.webp";